export class EquipmentUtil {
  static getDefaultImage(equipmentType: string, rotatingEqDefaultImageId?: string): string {
    switch (equipmentType) {
      case 'flange':
      case 'Flange':
        return 'assets/images/default_equipments/Flange.png';

      case 'pipe':
      case 'Pipe':
        return 'assets/images/default_equipments/Pipe.png';

      case 'steamtrap':
      case 'Steam Trap':
        return 'assets/images/default_equipments/Steamtrap.png';

      case 'tank':
      case 'Tank':
        return 'assets/images/default_equipments/Tank.png';

      case 'valve':
      case 'Valve':
        return 'assets/images/default_equipments/Valve.png';

      case 'rotatingEqu':
      case 'Rotating Equipment':
        return this.getRotatingEquipmentImage(rotatingEqDefaultImageId);

      default:
        return 'assets/images/default_sensor.png';
    }
  }

  private static getRotatingEquipmentImage(rotatingEqDefaultImageId?: string): string {
    switch (rotatingEqDefaultImageId) {
      case 'rotatingeqCentrifuge':
        return 'assets/images/Loctite-pulse-smart-Centrifuge.png';

      case 'rotatingeqCompressor':
        return 'assets/images/Loctite-pulse-smart-Compressorr.png';

      case 'rotatingeqMotor':
        return 'assets/images/Loctite-pulse-smart-Motor.png';

      case 'rotatingeqFan':
        return 'assets/images/Loctite-pulse-smart-Fan.png';

      case 'rotatingeqGearbox':
        return 'assets/images/Loctite-pulse-smart-Gear-box.png';

      case 'rotatingeqPump':
        return 'assets/images/Loctite-pulse-smart-Pump.png';

      case 'rotatingeqOther':
        return 'assets/images/rotating_other.png';

      default:
        return 'assets/images/default_equipments/rotatingEqu.png';
    }
  }
}
